import "./style.scss"
import '@fancyapps/fancybox'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'
$(document).ready(function(){
    var navTop = $('nav').offset().top;
    $(window).on('resize scroll', function() {
        if (($(window).width()> 768) && ($(window).scrollTop() > navTop)) {
            $('nav').addClass('fixed');
        } else {
            $('nav').removeClass('fixed');
        }  
    
        var position = $(this).scrollTop();
        $('section').each(function() {
            var target = $(this).offset().top - 100;
            var height = $(this).outerHeight();
            var id = $(this).attr('id');
            $('nav a[data-anchor=' + id + ']').removeClass('active');
            if (position >= target && position < target + height ) {
                $('nav a[data-anchor=' + id + ']').addClass('active');
            }
        });

    }).resize();

    
    $('nav a').on('click', function(e) {
        $('nav a').not('#lang a').removeClass("active");       
        $('nav').removeClass("active");
        if ($(window).width() < 769) {
            $('nav:not(.m-menu)').css({'right':'-60%', 'opacity':'0'});
        }
        if ($(this).data("anchor")) {
            e.preventDefault();
            $(this).addClass("active");
            var anchor = $("#anchor_" + $(this).data("anchor")).offset().top;
            if($(window).width() < 769) {
                var anchor = $("#anchor_" + $(this).data("anchor")).offset().top;
            }
            $("html").animate({ scrollTop: anchor - 100}, 600);
            $("body").animate({ scrollTop: anchor - 100 }, 600);

        }
    });

});